import { z } from 'zod';

/**
 * Which page of a list a response is, and how long the list is behind it —
 * the `page` object a paged endpoint puts beside its `items`. The server
 * clamps both numbers, so the pager draws what it was told, not what it asked.
 */
export const pageInfoSchema = z.object({
  page: z.number().int().positive(),
  perPage: z.number().int().positive(),
  total: z.number().int().nonnegative(),
  lastPage: z.number().int().positive(),
});

export type PageInfo = z.infer<typeof pageInfoSchema>;

/** `?page=&perPage=` appended to a path, keeping whatever query it already had. */
export function withPage(path: string, page: number, perPage: number): string {
  const query = new URLSearchParams({ page: String(page), perPage: String(perPage) }).toString();

  return `${path}${path.includes('?') ? '&' : '?'}${query}`;
}
